export const paletteColorful = {
  // --------- basic colors -----------
  basicColors: [
    '#FFFFFF',
    '#F4F7FE',
    '#DDE7FD',
    '#3471F9',
    '#2C60D3',
    '#2C60D3',
    '#0000EE',
    '#326EF4',
    '#FFFFFF',
    '#E0E9FE',
    '#5286F9',
    '#5286F9',
    '#3471F9',
    '#282B33',
    '#121826',
  ],

  // ---------- semantic colors ----------
  semanticColors: {
    red: '#FF4D4F',
    green: '#29A294',
  },
};
